<div class="individual-form-dialog container-fluid">
  <form [formGroup]="formGroup">
    <div class="row pt-4">
      <div class="col">
        <h3 class="subheading-2">Clear Pending Payment</h3>
      </div>
    </div>   

    <div class="row">
      <div class="col-12">
        <mat-form-field>
          <mat-label>Response File</mat-label>
          <input matInput type="text" [formControl]="formControlResponseFile">
        </mat-form-field> 
      </div>
    </div> 

    <div class="row pb-4">
      <div class="col">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-stroked-button (click)="onCancel()">Cancel</button>
          <button mat-flat-button color="primary" (click)="onSubmit()">Confirm</button>
        </div>
      </div>
    </div>
  </form>
</div>
